import React, { useCallback, useEffect, useState } from 'react';
import AdminApi from './AdminApi';

/**
 * Hàng đợi chờ duyệt (feature 002 - US2).
 * CHECKER/ADMIN xem các bài Approval_Status=0 và Duyệt / Từ chối.
 */
const POST_TYPE_NAMES = {
    10: 'Trang', 16: 'Tin tức', 17: 'Video', 18: 'Audio', 19: 'Kinh sách',
    22: 'Thông báo', 23: 'Hình ảnh', 24: 'Nhạc Phật Giáo', 25: 'Sách nói',
    26: 'Giảng sư', 27: 'Gương Sáng Tu Hành', 28: 'Audio Theo Bộ'
};

const AdminPendingPage = () => {
    const [rows, setRows] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState(null);
    const [rejecting, setRejecting] = useState(null); // {id, title}
    const [rejectNote, setRejectNote] = useState('');

    const load = useCallback(async (p = 1) => {
        setIsLoading(true);
        try {
            const res = await AdminApi.getPendingPosts(p);
            setRows(res.data || []);
            setTotalPages(res.totalPages || 1);
            setTotalRecords(res.totalRecords || 0);
            setPage(p);
        } catch {
            setMessage({ type: 'error', text: 'Không tải được danh sách chờ duyệt.' });
        }
        setIsLoading(false);
    }, []);

    useEffect(() => { load(1); }, [load]);

    const doApprove = async (row) => {
        setMessage(null);
        try {
            await AdminApi.approvePost(row.id);
            setMessage({ type: 'success', text: `Đã duyệt: "${row.title}"` });
            load(page);
        } catch {
            setMessage({ type: 'error', text: 'Duyệt thất bại (kiểm tra quyền/kết nối).' });
        }
    };

    const doReject = async () => {
        if (!rejecting) return;
        setMessage(null);
        try {
            await AdminApi.rejectPost(rejecting.id, rejectNote);
            setMessage({ type: 'success', text: `Đã từ chối: "${rejecting.title}"` });
            setRejecting(null); setRejectNote('');
            load(page);
        } catch {
            setMessage({ type: 'error', text: 'Từ chối thất bại (kiểm tra quyền/kết nối).' });
        }
    };

    const fmtDate = (d) => d ? new Date(d).toLocaleString('vi-VN') : '';

    return (
        <div className="social-box">
            <h3 className="page-title">Chờ duyệt {totalRecords > 0 && <span style={{ fontSize: '13px', color: '#6b7684', fontWeight: 500 }}>({totalRecords} bài)</span>}</h3>
            <div className="body">
                {message && (
                    <div style={{
                        padding: '10px 14px', borderRadius: '8px', marginBottom: '14px', fontWeight: 600,
                        background: message.type === 'success' ? '#e7f6ec' : '#fdecec',
                        color: message.type === 'success' ? '#1c8c3c' : '#cf383d',
                        border: `1px solid ${message.type === 'success' ? '#bfe5cb' : '#f5c6c6'}`
                    }}>{message.text}</div>
                )}

                {isLoading ? <p>Đang tải…</p> : rows.length === 0 ? (
                    <p style={{ color: '#6b7684' }}>🎉 Không có bài nào chờ duyệt.</p>
                ) : (
                    <table className="table table-hover">
                        <thead>
                            <tr>
                                <th style={{ width: '40px' }}>STT</th>
                                <th>Tiêu đề</th>
                                <th style={{ width: '130px' }}>Loại</th>
                                <th style={{ width: '110px' }}>Người tạo</th>
                                <th style={{ width: '150px' }}>Ngày gửi</th>
                                <th style={{ width: '180px' }}>Thao tác</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((r, i) => (
                                <tr key={r.id}>
                                    <td>{(page - 1) * 15 + i + 1}</td>
                                    <td><strong>{r.title}</strong></td>
                                    <td>{POST_TYPE_NAMES[r.type] || `Loại ${r.type}`}</td>
                                    <td>{r.user_create}</td>
                                    <td>{fmtDate(r.date_edit || r.date_create)}</td>
                                    <td>
                                        <button className="btn btn-success btn-small" onClick={() => doApprove(r)}>✓ Duyệt</button>{' '}
                                        <button className="btn btn-danger btn-small" onClick={() => { setRejecting(r); setRejectNote(''); }}>✕ Từ chối</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}

                {totalPages > 1 && (
                    <div style={{ marginTop: '12px' }}>
                        {Array.from({ length: totalPages }, (_, i) => i + 1).map(p => (
                            <button key={p} className={`btn btn-small ${p === page ? 'btn-primary' : ''}`} style={{ marginRight: '4px' }} onClick={() => load(p)}>{p}</button>
                        ))}
                    </div>
                )}
            </div>

            {rejecting && (
                <div className="modal-overlay1">
                    <div className="modal1">
                        <p>Từ chối bài: <strong>{rejecting.title}</strong></p>
                        <textarea
                            placeholder="Lý do từ chối (tùy chọn, maker sẽ nhìn thấy)"
                            value={rejectNote}
                            onChange={e => setRejectNote(e.target.value)}
                            style={{ width: '100%', minHeight: '80px', margin: '10px 0' }}
                        />
                        <div className="modal-actions1">
                            <button className="btn btn-danger" onClick={doReject}>Xác nhận từ chối</button>
                            <button className="btn btn-secondary" onClick={() => setRejecting(null)}>Hủy</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AdminPendingPage;
